import { useMemo } from "react";
import { Option, OptionText, ImgContainer } from "./Questions.style";
import { htmlDecode, removeEqualQuotes } from "../../utils/parse";

function Descriptive(props) {
  const { option, isQuestionImg } = props;

  const imageURL = useMemo(() => {
    if (!props.images) return null;
    return props.images.startsWith("https://drive.g") ? null : props.images;
  }, [props.images]);

  return (
    <div className="optioncontainer" style={{ width: "100%" }}>
      <Option isQuestionImg={isQuestionImg}>
        {props.label && <h2 style={{ fontSize: "0.8rem", fontWeight: "bold", margin: 0 }}>
          {props.label}
        </h2>}
        <div
          style={{
            width: "100%",
            border: "1px solid #5ce0d2",
            borderRadius: "10px",
            padding: "9px",
          }}
        >
          <OptionText cas>
            <div
              style={{ width: "100%" }}
              dangerouslySetInnerHTML={{
                __html: htmlDecode(removeEqualQuotes(option?.value || "")),
              }}
            ></div>
          </OptionText>

          {imageURL && (
            <ImgContainer>
              <img src={imageURL} alt="optionsImage" />
            </ImgContainer>
          )}
        </div>
      </Option>
    </div>
  );
}

export default Descriptive;
